import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import StaffClaimDocumentsDrawer from "./StaffClaimDocumentsDrawer";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
  imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
  StaffClaimApplications,
  staffClaimApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, staffClaimApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ClaimApplicationForm from "./form";

const base_url = HRService.uri;

function StaffClaimsByUserTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedClaimForDocs, setSelectedClaimForDocs] = useState(null);

  const actions = {
    isSubright: true,
    entity: "Staff Claims",

    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },

    // ---------- APPROVE ----------
      sendForapprovalStaffClaim: {
      key: "SENDFORAPPROVAL",
      button_name: "Sent For Approval",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },


    // ---------- REJECT ----------
    // REJECTCLAIM: {
    //   key: "REJECTCLAIM",
    //   button_name: "Reject",
    //   Show_Button: (row) => row.statusId === 1,   // only when pending
    //   permission: "hasNoPermission",
    //   roleGroupId: [1, 2, 3, 4],
    // },
    ViewClaimLines: {
      key: "ViewClaimLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedClaimForDocs(row);
        setDocsDrawerOpen(true);
      },
    },
    showStatus: true,
  };

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Claim Applications"
          subtitle="View all your Claim Applications, create or update it"
          columns={staffClaimApplicationsColumns}
          FormComponent={ClaimApplicationForm}
          query={StaffClaimApplications}
          actions={actions}
          base_url={base_url}
        />
        <StaffClaimDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedClaimForDocs(null);
          }}
          claimId={selectedClaimForDocs?.id}
        />
      </>
    </Box>
  );
}

export default StaffClaimsByUserTable;
